import type { DocMigration } from "../docMigration";
import { forEachFormula } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_74: DocMigration = {
  maxSchemaVersion: "0.0.74",
  description: "Make params single, flat table",
  apply(json: any) {
    const rooms = json.rooms;

    if (!json.params) {
      json.params = {};
    }

    if (!json.paramRefs) {
      json.paramRefs = {};
    }

    const params = json.params;
    const paramRefs = json.paramRefs;

    for (const roomId in rooms) {
      const room = rooms[roomId];
      let counter = 0;

      if (room.params) {
        for (const paramId in room.params) {
          const newParamId = paramId + roomId;

          params[newParamId] = room.params[paramId];

          paramRefs[newParamId] = {
            type: "PARAM_REF",
            id: newParamId,
            parentId: roomId,
            sortIndex: counter++,
          };

          const replaceFormulasForRoom = (v) => {
            forEachFormula(v, (f) => {
              (f as any).formula = f.formula.replace(new RegExp(paramId, "g"), newParamId);
            });
          };

          if (json.roomLayouts?.[roomId]) {
            replaceFormulasForRoom(json.roomLayouts[roomId]);
          }

          if (json.drawings) {
            for (const id in json.drawings) {
              const e = json.drawings[id];
              if (e.parentId === roomId) {
                replaceFormulasForRoom(e);
              }
            }
          }

          if (json.casework) {
            for (const id in json.casework) {
              const e = json.casework[id];
              if (e.parentId === roomId) {
                replaceFormulasForRoom(e);
              }
            }
          }

          if (json.annotation) {
            for (const id in json.annotation) {
              const e = json.annotation[id];
              if (e.parentId === roomId) {
                replaceFormulasForRoom(e);
              }
            }
          }
        }
      }

      delete room.params;
    }

    if (json.design) {
      flattenDesign0075(json.design);
    }

    return json;
  },
};

function flattenDesign0075(design: any) {
  if (design.roomParamValues) {
    for (const roomId in design.roomParamValues) {
      for (const paramId in design.roomParamValues[roomId]) {
        design[paramId + roomId] = design.roomParamValues[roomId][paramId];
      }
    }

    delete design.roomParamValues;
  }

  if (design.partiParamValues) {
    Object.assign(design, design.partiParamValues);
    delete design.partiParamValues;
  }

  return design;
}

export default migration_0_0_74;
